import { gql } from '@apollo/client';

export const DELETE_VACANCY = gql`
  mutation DeleteAd($id: ID!, $adType: AdTypeEnum = VACANCY) {
    deleteAd(input: { id: $id, adType: $adType }) {
      status
    }
  }
`;

export const CREATE_VACANCY = gql`
  mutation CreateVacancy(
    $ageFrom: Int
    $ageTo: Int
    $categoryId: ID
    $contact: String
    $description: String
    $educationId: ID
    $experienceId: ID
    $positionName: String
    $regionId: ID
    $salaryFrom: Int
    $salaryTo: Int
    $isDraft: Boolean
    $phones: [String!]
    $email: String
  ) {
    createVacancy(
      input: {
        ageFrom: $ageFrom
        ageTo: $ageTo
        categoryId: $categoryId
        contact: $contact
        description: $description
        educationId: $educationId
        experienceId: $experienceId
        positionName: $positionName
        regionId: $regionId
        salaryFrom: $salaryFrom
        salaryTo: $salaryTo
        isDraft: $isDraft
        phones: $phones
        email: $email
      }
    ) {
      status
      errors {
        code
        message
        path
      }
      ad {
        activationStatus
        ageFrom
        ageTo
        approvedAt
        awaitingPayment
        bumpedAt
        categoryId
        createdAt
        contactName
        daysLeft
        deletable
        description
        draft
        education
        educationId
        experience
        experienceId
        expirable
        isBookmarked
        isBumped
        isFeatured
        isMine
        jobDescription
        location
        logo
        name
        positionName
        regionId
        rejectReason
        requirements
        responsibilities
        salaryFrom
        salaryTo
        status
        updatedAt
        id
        phones
        email
      }
    }
  }
`;

export const CREATE_BOOKMARK_VACANCY = gql`
  mutation createBookmarkVacancy($adId: ID!, $adType: AdTypeEnum = VACANCY) {
    createBookmark(input: { id: $adId, adType: $adType }) {
      status
    }
  }
`;

export const DELETE_BOOKMARK_VACANCY = gql`
  mutation deleteBookmarkVacancy($adId: ID!, $adType: AdTypeEnum = VACANCY) {
    deleteBookmark(input: { id: $adId, adType: $adType }) {
      status
    }
  }
`;

export const FREE_ACTIVATE_VACANCY = gql`
  mutation FreeActivateVacancy($id: ID!) {
    freeActivateVacancy(id: $id) {
      status
      errors {
        code
        message
        path
      }
    }
  }
`;
